(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cyel-pdp-lookbook"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initLook(root) {
      if (root.__lookInit) return;
      root.__lookInit = true;

      var track = root.querySelector('[data-look-track]');
      if (!track) return;
      var bar = root.querySelector('[data-look-bar]');
      var prev = root.querySelector('[data-look-prev]');
      var next = root.querySelector('[data-look-next]');

      function step() {
        var item = track.querySelector('.cyel-look__item');
        if (!item) return track.clientWidth * 0.8;
        var gap = parseFloat(getComputedStyle(track).gap) || 0;
        return item.getBoundingClientRect().width + gap;
      }

      function update() {
        var max = track.scrollWidth - track.clientWidth;
        if (bar) {
          var p = max > 0 ? track.scrollLeft / max : 1;
          bar.style.transform = 'scaleX(' + Math.max(0.08, Math.min(1, p || 0.08)) + ')';
        }
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max - 2;
      }

      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });

      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);

      // Glisser-déposer (souris) : on annule le clic si l'utilisateur a réellement glissé
      var down = false, moved = 0, startX = 0, startScroll = 0;

      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        down = true; moved = 0;
        startX = e.clientX;
        startScroll = track.scrollLeft;
        track.classList.add('is-dragging');
      });

      window.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        moved = Math.abs(dx);
        track.scrollLeft = startScroll - dx;
      });

      window.addEventListener('pointerup', function () {
        if (!down) return;
        down = false;
        track.classList.remove('is-dragging');
        if (moved > 6) {
          var kill = function (ev) { ev.preventDefault(); ev.stopPropagation(); };
          track.addEventListener('click', kill, { capture: true, once: true });
          setTimeout(function () { track.removeEventListener('click', kill, { capture: true }); }, 0);
        }
      });

      update();
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('.cyel-look').forEach(initLook);
    }

    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', function () { initAll(); });

    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["departure-board"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';

    var cells = Array.prototype.slice.call(document.querySelectorAll('[data-board-flap]'));
    cells.forEach(function (el) {
      var text = el.textContent.trim();
      el.textContent = '';
      var letters = [];
      text.split('').forEach(function (ch) {
        var s = document.createElement('span');
        if (ch === ' ') {
          s.className = 'cyel-flap cyel-flap--space';
          s.innerHTML = '&nbsp;';
        } else {
          s.className = 'cyel-flap';
          s.textContent = ch;
          letters.push({ node: s, final: ch });
        }
        el.appendChild(s);
      });
      el._cyelLetters = letters;
    });

    function flipCell(el, baseDelay) {
      el.classList.add('is-flipping');
      (el._cyelLetters || []).forEach(function (l, i) {
        l.node.style.animationDelay = (baseDelay + i * 35) + 'ms';
        var swaps = 0;
        var iv = setInterval(function () {
          swaps++;
          if (swaps > 2 + (i % 3)) {
            l.node.textContent = l.final;
            clearInterval(iv);
          } else {
            l.node.textContent = CHARS[Math.floor(Math.random() * CHARS.length)];
          }
        }, 65 + i * 8);
      });
    }

    var panel = document.querySelector('.cyel-board__panel');
    if (!panel) return;

    function run() {
      if (reduce) return;
      var rows = panel.querySelectorAll('.cyel-board__row');
      rows.forEach(function (row, r) {
        row.querySelectorAll('[data-board-flap]').forEach(function (cell, c) {
          setTimeout(function () { flipCell(cell, 0); }, r * 220 + c * 90);
        });
      });
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { run(); io.unobserve(e.target); }
        });
      }, { threshold: 0.3 });
      io.observe(panel);
    } else {
      run();
    }

    var clock = document.querySelector('[data-cyel-clock] .cyel-board__clock-time');
    if (clock) {
      function tick() {
        var d = new Date();
        var utc = d.getTime() + d.getTimezoneOffset() * 60000;
        var mia = new Date(utc - 4 * 3600000);
        function p(n) { return (n < 10 ? '0' : '') + n; }
        clock.textContent = p(mia.getHours()) + ':' + p(mia.getMinutes()) + ':' + p(mia.getSeconds());
      }
      tick();
      setInterval(tick, 1000);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dpm-collection-grid"]) return;
  try {
    
  (function () {
    /* Filtres par type */
    document.querySelectorAll('[data-cvest-filters]').forEach(function (bar) {
      var groups = bar.parentNode.querySelectorAll('.cvest__group');
      bar.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-cvest-filter]'); if (!btn) return;
        bar.querySelectorAll('.cvest__chip').forEach(function (c) { c.classList.remove('is-on'); });
        btn.classList.add('is-on');
        var f = btn.getAttribute('data-cvest-filter');
        groups.forEach(function (g) { g.classList.toggle('is-hidden', f !== 'all' && g.getAttribute('data-group') !== f); });
      });
    });

    /* Pixel-trail (fond vivant, couleur marque) */
    document.querySelectorAll('[data-cx-pixeltrail]').forEach(function (cv) {
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce) return;
      var ctx = cv.getContext('2d');
      var host = cv.parentNode, cell = 30, cols = 0, rows = 0, grid = [], dpr = Math.min(window.devicePixelRatio || 1, 2);
      function resize() {
        var w = host.clientWidth, h = host.clientHeight;
        cv.width = w * dpr; cv.height = h * dpr; cv.style.width = w + 'px'; cv.style.height = h + 'px';
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        cols = Math.ceil(w / cell); rows = Math.ceil(h / cell); grid = new Float32Array(cols * rows);
      }
      function onMove(e) {
        var r = host.getBoundingClientRect();
        var x = e.clientX - r.left, y = e.clientY - r.top;
        var cx = Math.floor(x / cell), cy = Math.floor(y / cell);
        for (var dy = -1; dy <= 1; dy++) for (var dx = -1; dx <= 1; dx++) {
          var gx = cx + dx, gy = cy + dy;
          if (gx >= 0 && gy >= 0 && gx < cols && gy < rows) {
            var d = Math.abs(dx) + Math.abs(dy);
            grid[gy * cols + gx] = Math.min(1, grid[gy * cols + gx] + (d === 0 ? 1 : .5));
          }
        }
      }
      function frame() {
        ctx.clearRect(0, 0, cv.width, cv.height);
        for (var i = 0; i < grid.length; i++) {
          var v = grid[i]; if (v < .02) continue;
          grid[i] = v * .9;
          var gx = (i % cols) * cell, gy = Math.floor(i / cols) * cell;
          ctx.fillStyle = 'rgba(255,200,61,' + (v * .5).toFixed(3) + ')';
          ctx.fillRect(gx + 3, gy + 3, cell - 6, cell - 6);
        }
        requestAnimationFrame(frame);
      }
      resize(); window.addEventListener('resize', resize);
      host.addEventListener('mousemove', onMove, { passive: true });
      requestAnimationFrame(frame);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-douane"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var isMobile = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;

    document.querySelectorAll('.np-type').forEach(function (el) {
      var textEl = el.querySelector('.np-type__text');
      if (!textEl) return;

      var texts = (el.getAttribute('data-texts') || '').split('|').map(function (t) { return t.trim(); }).filter(Boolean);
      if (!texts.length) return;

      if (reduce || isMobile) { textEl.textContent = texts[0]; el.classList.add('np-type--static'); return; }

      var speed = parseInt(el.getAttribute('data-speed'), 10) || 60;
      var deleteSpeed = parseInt(el.getAttribute('data-delete-speed'), 10) || 30;
      var wait = parseInt(el.getAttribute('data-wait'), 10) || 2000;
      var initialDelay = parseInt(el.getAttribute('data-initial-delay'), 10) || 300;
      var loop = el.getAttribute('data-loop') === 'true';

      var ti = 0, ci = 0, deleting = false;
      textEl.textContent = '';

      function tick() {
        var current = texts[ti];
        if (!deleting) {
          ci++;
          textEl.textContent = current.slice(0, ci);
          if (ci >= current.length) {
            if (!loop && texts.length === 1) return;
            deleting = true;
            return setTimeout(tick, wait);
          }
          return setTimeout(tick, speed);
        } else {
          ci--;
          textEl.textContent = current.slice(0, ci);
          if (ci <= 0) {
            deleting = false;
            ti = (ti + 1) % texts.length;
            if (!loop && ti === 0) { textEl.textContent = texts[texts.length - 1]; return; }
            return setTimeout(tick, speed);
          }
          return setTimeout(tick, deleteSpeed);
        }
      }
      setTimeout(tick, initialDelay);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-triptych"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-np-sync]').forEach(function (strip) {
      var vids = Array.prototype.slice.call(strip.querySelectorAll('video'));
      if (vids.length !== 3) { vids.forEach(function (v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }); return; }
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return; // posters seuls

      var master = vids[0];
      var DRIFT = 0.034; // ~1 frame @30fps

      function startAll() {
        vids.forEach(function (v) { try { v.currentTime = 0; } catch (e) {} var p = v.play(); if (p && p.catch) p.catch(function () {}); });
      }
      function correct() {
        if (master.paused) return;
        for (var i = 1; i < vids.length; i++) {
          if (Math.abs(vids[i].currentTime - master.currentTime) > DRIFT) {
            try { vids[i].currentTime = master.currentTime; } catch (e) {}
          }
        }
      }
      // Recalage image par image si dispo
      function rvfcLoop() { correct(); if ('requestVideoFrameCallback' in master) { try { master.requestVideoFrameCallback(rvfcLoop); } catch (e) {} } }

      var ready = vids.map(function (v) {
        return (v.readyState >= 3) ? Promise.resolve()
          : new Promise(function (res) { v.addEventListener('canplaythrough', function () { res(); }, { once: true }); });
      });
      Promise.all(ready).then(function () { startAll(); if ('requestVideoFrameCallback' in master) rvfcLoop(); });

      // Filet de sécurité (si rVFC absent, ou canplaythrough tarde)
      setInterval(correct, 250);
      setTimeout(function () { if (master.paused) startAll(); }, 2500);

      // Retour d'onglet : re-synchro forcée (les timers se figent en arrière-plan)
      document.addEventListener('visibilitychange', function () { if (!document.hidden) startAll(); });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
